import copy from 'copy-to-clipboard';

common.View.create('habitats.website.layouts.main.ShareCustom', {

	onDOMLoad()
	{
		//
		this.initButtons();
	},

	initButtons()
	{
		this.element

			// Listen for buttons click.
			.find('a')
				.click(this.onButtonClick.bind(this))
				.end()
	},

	onButtonClick(event)
	{
		// Copy link?
		if($(event.currentTarget).attr('data-ga-action') == 'Link')
			this.copyLink(event);

		// Or open share popup?
		else
			window.open($(event.target).attr('href'), 'Share', 'height=450, width=600, top=' + ($(window).height() / 2 - (450 / 2)) + ', left=' + ($(window).width() / 2 - (600 / 2)) + ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');

		// @ugly We kind of do assume GA has been loaded.
		// Trigger GA Event.
		if(window.ga)
			ga('send', 'event', 'Share', $(event.currentTarget).attr('data-ga-action'), this.element.attr('data-ga-label'), this.element.attr('data-ga-value'));

		// Avoid navigating.
		return false;
	},

	copyLink(event)
	{
		// Copy to clipboard.
		copy($(event.currentTarget).attr('href'));

		// Notify
		var timeout;

		let successElement = $(event.currentTarget)

			// Fade in.
			.find('.success')
				.stop()
				.fadeIn('slow', () =>
				{
					if(timeout)
						clearTimeout(timeout)

					// @ugly Wait since .delay() wont work?
					timeout = setTimeout(() =>
					{
						successElement
							.stop()
							.fadeOut('slow');
					}, 500);
				});
	},

});
